export const Title = ({ title, subtitle }: { title?: string; subtitle?: string }) => {
  return (
    <div className="flex flex-col pt-6 pb-8 text-center sm:pt-8 sm:pb-8 text-text-dark">
      <div className="text-2xl font-extrabold sm:text-3xl">{title}</div>
      <div className="mt-3 text-base font-medium">{subtitle}</div>
    </div>
  );
};
